module.exports = __webpack_public_path__ + "img/icon_tt_bul_on02.7141712e.svg";